module.exports = __webpack_public_path__ + "img/lucky5_icon.49456846.png";